import useSWR from "swr";
import { getKanban } from "../api/crm";
import { useAuth } from "./useAuth";

export function useLeadsKanban(params = {}) {
  const { auth } = useAuth();

  const swrKey = auth?.token ? ["/crm/kanban", auth.token, params] : null;

  const { data, error, isLoading, mutate } = useSWR(
    swrKey,
    ([, token, p]) => getKanban(token, p),
    { revalidateOnFocus: true }
  );

  return {
    stages: data || [],
    isLoading,
    isError: !!error,
    refresh: mutate,
  };
}
